var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0311 15L35 20.25L31.9689 15L38.0311 15ZM35.866 22.75C35.4811 23.4167 34.5189 23.4167 34.134 22.75L29.3708 14.5C28.9859 13.8333 29.4671 13 30.2369 13H39.7631C40.5329 13 41.0141 13.8333 40.6292 14.5L38.6726 17.8889C43.9191 20.6493 47.5 26.1556 47.5 32.5C47.5 41.6127 40.1127 49 31 49C21.8873 49 14.5 41.6127 14.5 32.5C14.5 28.5379 15.8978 24.8995 18.2262 22.0551C18.576 21.6278 19.2061 21.5649 19.6334 21.9147C20.0608 22.2646 20.1236 22.8946 19.7738 23.322C17.7272 25.8221 16.5 29.0164 16.5 32.5C16.5 40.5081 22.9919 47 31 47C39.0081 47 45.5 40.5081 45.5 32.5C45.5 26.8992 42.3248 22.0383 37.6717 19.6224L35.866 22.75Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.f5099aefda42e75428264ae86eed2601.svg";
export { ForwardRef as ReactComponent };